import { Link } from 'react-router-dom';
import { BarChart3, X } from 'lucide-react';
import { useCompare } from '../context/CompareContext';

export default function CompareBar() {
    const { compareIds, removeFromCompare, clearCompare, compareCount } = useCompare();

    if (compareCount === 0) return null;

    return (
        <div className="compare-bar">
            <div className="compare-bar-inner">
                <div className="compare-bar-info">
                    <BarChart3 size={18} />
                    <span>{compareCount} ürün karşılaştırmada</span>
                </div>
                <div className="compare-bar-actions">
                    <Link to="/karsilastir" className="compare-bar-btn compare-bar-go">
                        Karşılaştır
                    </Link>
                    <button className="compare-bar-btn compare-bar-clear" onClick={clearCompare}>
                        <X size={14} /> Temizle
                    </button>
                </div>
            </div>
        </div>
    );
}
